import moment from 'moment'
import { Link } from 'react-router-dom'
import Icon from '@/components/Icon'
import { Popover } from '@/components/popover'
import Resx from '@/components/Resx'
import React, { useCallback, useEffect, useState } from 'react'
import { useLocalization } from '@/hooks/localization'

export function NotificationItem ({ id, state, notification, menuNotifications, onRead }) {
  const { localizeValue } = useLocalization()
  const [processing, setProcessing] = useState(false)

  const onToggleRead = useCallback(() => {
    setProcessing(true)
    onRead({ id, state: !state ? 1 : 0 })
  }, [id, onRead, state])

  useEffect(() => {
    setProcessing(false)
  }, [state])

  const onNavigate = useCallback(() => {
    if (!state) {
      onToggleRead()
    }
  }, [onToggleRead, state])

  if (!notification.data) return null
  const { url, icon, message, latinMessage } = notification.data
  const time = moment.utc(notification.creationTime)
  const fromNow = time.fromNow()
  const exactTime = time.local().format('l LTS')
  const dotClass = state === 1 ? 'notify-dot' : 'notify-dot notify-dot--new'
  const itemClass = state === 1 ? 'd-notification__item' : 'd-notification__item d-notification__item--new'
  const overlayClassName = `antd-popover-black ${menuNotifications && 'antd-popover-menu'}`
  return (
    <div className={itemClass}>
      <Link to={url || '/notification-url-null'} onClick={onNavigate}>
        <div className='d-notification__message'>
          <span dangerouslySetInnerHTML={{ __html: localizeValue(message, latinMessage) }} />
        </div>
      </Link>
      <div className='d-flex justify-content-between align-items-center'>
        {icon ? <span className='notification-type'><Icon name={icon} /></span> : null}
        <div className='d-flex align-items-center'>
          <Popover
            content={exactTime}
            overlayClassName={overlayClassName}
            getPopupContainer={() => document.querySelector('.main-body')}
            placement='top'
          >{<time>{fromNow}</time>}
          </Popover>

          <div className='d-notification__dot' id={'notify-' + id}>
            <Popover
              overlayClassName={overlayClassName}
              content={state === 1 ? <Resx name='NotificationsUI.MarkAsUnread' /> : <Resx name='NotificationsUI.MarkAsRead' />}
              getPopupContainer={() => document.querySelector('body')}
              placement='top'>{processing ? <div className={dotClass} style={{ background: '#e5e5e5' }} /> : <button className={dotClass} onClick={onToggleRead} />}
            </Popover>
          </div>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/notifications/notificationItem.js